<template>
  <v-container fluid>
    <v-data-table
      :headers="header"
      :items="items"
      :search="search"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon @click="listarBitacora()" v-bind="attrs" v-on="on">
                fa-solid fa-rotate-right
              </v-icon>
            </template>
            <span>Actualizar</span>
          </v-tooltip>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-toolbar-title>Bitacora</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            :label="$t('search')"
            outlined
            dense
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>

      <template v-slot:[`item.fecha`]="{ item }">
        {{ formatoFecha(item.fecha) }}
      </template>

      <template v-slot:[`item.enviado`]="{ item }">
        <v-chip color="green" dark v-if="item.enviado">SI</v-chip>
        <v-chip color="red" dark v-else>NO</v-chip>
      </template>
    </v-data-table>
  </v-container>
</template>  

<script>
import axios from "axios";
import moment from "moment";

export default {
  data: () => ({
    search: "",
    loading: false,
    header: [
      { text: "Fecha", value: "fecha" },
      { text: "Sello", value: "cod_factura" },
      { text: "Correos", value: "listado_correos" },
      { text: "Enviado", value: "enviado", align: "center" },
      { text: "Razón", value: "razon" },
    ],
    items: [],
  }),
  created() {
    this.listarBitacora();
  },
  methods: {
    listarBitacora() {
      this.loading = true;
      axios
        .get("api/BitacoraCorreoFe/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          //console.log(response.data);
          this.items = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    formatoFecha(fecha) {
      if (!fecha) {
        return "";
      }

      return moment(fecha).format("yyyy-MM-DD hh:mm");
    },
  },
};
</script>